<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <v-row class="mb-2">
    <v-col cols="7" class="mx-n4 mt-1">
      <v-card-title>Promouvoir une catégorie</v-card-title>
    </v-col>
    <v-col cols="8" class="mt-n7">
      <v-autocomplete
        v-model="facetNewValue.facet"
        item-text="label"
        item-value="value"
        item-color="info"
        menu-props="light"
        label="Sélectionner une catégorie"
        :items="facetsList"
        :rules="[v=>!!v || 'Required']"
        color="blue"
        clearable
        @change="changeFacet"
      />
    </v-col>

    <v-col cols="2" class="mx-8 mt-n8">
      <v-text-field
        v-model.number="facetNewValue.score"
        color="blue"
        type="number"
        label="Score"
        :rules="[isPositiveInteger]"
      />
    </v-col>

    <v-col cols="10">
      <FacetValuesSelection
        v-model="facetNewValue.values"
        :facet="facetNewValue.facet"
        :allow-copy="!disableCopyPaste"
        :disabled="!facetNewValue.facet"
        :search-by-query="searchByQuery"
        :rules="[v => v.length > 0|| 'Required']"
      />
    </v-col>
  </v-row>
</template>

<script setup>

import { ref } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import FacetValuesSelection from './common/FacetValuesSelection.vue';

const { useFacetSettings } = require('@/utils/merch');
const { isPositiveInteger } = require('@/utils');

const props = defineProps({ action: { type: Object, required: true } });
const store = useStore();
const facetNewValue = ref(props.action);

const { disableCopyPaste, searchByQuery, facetsList, facetSettings } = useFacetSettings(facetNewValue, store.getters.ruleFacets);

const changeFacet = val => {
  facetNewValue.value.values = [];
};

const tempFix = () => {
  if (facetNewValue.value.values && !Array.isArray(facetNewValue.value.values)) {
    facetNewValue.value.values = [{ value: facetNewValue.value.values }];
  }
};

tempFix();

if (!facetNewValue.value.score) {
  facetNewValue.value.score = 1;
}

</script>

<style>
</style>
